import {DatatableConfig} from "../types/DatatableConfig";

const defaultConfig : DatatableConfig = {
    tableMode: 'full',
    settingsShow: true,
}

export default defaultConfig
